module.exports = __webpack_public_path__ + "img/avatar.9aae418d.jpg";